import {css} from 'styled-components';
import {Card} from '../card/Card';
import {TarasaIcon} from '../Icon/TarasaIcon.tsx';

export const tabActiveState = (active) => {
    if (active) {
        return css`
            border: 1px solid var(--tab-option-border-active-color);
            background: var(--tab-option-background-active-color);
            color: var(--tab-option-text-active-color);
            svg,
            svg * {
                color: var(--tab-option-text-active-color);
            }

            ${TarasaIcon.Wrapper} {
                svg * {
                    fill: var(--tab-option-text-active-color) !important;
                }
            }

            &:hover {
                border: 1px solid var(--tab-option-border-active-hover-color);
                background: var(--tab-option-background-active-hover-color);
                color: var(--tab-option-text-active-color);
                ${TarasaIcon.Wrapper} {
                    svg * {
                        fill: var(--tab-option-text-active-color) !important;
                    }
                }
            }
        `;
    } else {
        return `
        `;
    }
};

export const tabSize = (size) => {
    if (size === 'sm')
        return css`
            ${Card.Body} {
                padding: 3px;
                gap: 1px;
            }
            link,
            a,
            button {
                font-size: var(--text-size-default);
                font-weight: 600;
                padding: 4px 6px;
                border-radius: 3px;
                height: unset;
                line-height: unset;
            }
        `;
    else
        return `
           
        `;
};

export const tabUiSetup = () => {
    return css`
        border: none;
        background: none;
        color: var(--unselected-tab-text-color);

        ${TarasaIcon.Wrapper} {
            svg * {
                fill: var(--unselected-tab-text-color) !important;
            }
        }

        &:hover {
            color: var(--tab-option-text-hover-color);
            ${TarasaIcon.Wrapper} {
                svg * {
                    fill: var(--tab-option-text-hover-color) !important;
                }
            }
        }

        cursor: pointer;
        padding: 2px 12px;
        border-radius: 6px;
        font-weight: 400;
        text-decoration: none;
        height: 28px;
        line-height: 1.6;
    `;
};
